import { render, staticRenderFns } from "./AgendaCard.vue?vue&type=template&id=59874ad8&"
import script from "./AgendaCard.vue?vue&type=script&lang=js&"
export * from "./AgendaCard.vue?vue&type=script&lang=js&"
import style0 from "./AgendaCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports